import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import { isPinApp } from 'signin-app/login/selectors';
const SelectStaffForPin = React.lazy(() => import('./select-staff-for-pin').then(module => ({ default: module.SelectStaffForPin })));
const SelectStaffForRoom = React.lazy(() => import('./select-staff-for-room').then(module => ({ default: module.SelectStaffForRoom })));
/** Only sites with the newer screens reach this screen, so it loads on demand */
export const SelectStaffRoute = () => {
    const isPin = useTypedSelector(isPinApp);
    return _jsx(React.Suspense, { fallback: null, children: isPin ? _jsx(SelectStaffForPin, {}) : _jsx(SelectStaffForRoom, {}) });
};
